import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconPaddingHorizontal12 from './IconPaddingHorizontal12';
import IconPaddingHorizontal16 from './IconPaddingHorizontal16';
import IconPaddingHorizontal20 from './IconPaddingHorizontal20';
import IconPaddingHorizontal24 from './IconPaddingHorizontal24';
import IconPaddingHorizontal32 from './IconPaddingHorizontal32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconPaddingHorizontal = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconPaddingHorizontal12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconPaddingHorizontal16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconPaddingHorizontal20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconPaddingHorizontal24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconPaddingHorizontal32 {...props} />}
        </span>
    );
};
IconPaddingHorizontal.displayName = 'FondueIconPaddingHorizontal';

export default memo(IconPaddingHorizontal);
